export default "__VITE_PUBLIC_ASSET__5250162e__"